import { render, staticRenderFns } from "./DialogConsultaCpf.vue?vue&type=template&id=1af3e852"
import script from "./DialogConsultaCpf.vue?vue&type=script&lang=js"
export * from "./DialogConsultaCpf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports